import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  // Environment & Instance
  environment: 'preprod',
  instanceId: '',

  // Query Mode
  queryMode: 'template',

  // Template Mode fields (cascading dropdowns)
  domain: 'debtors',
  resource: 'customers',
  action: 'list',

  // Pagination
  paginationMode: 'single', // 'single' or 'all'
  pageSize: 50,
  maxPages: 10,

  // Custom Mode fields
  operation: 'query',
  query: '',
  variables: '{}',

  // Headers
  sendHeaders: false,
  headerParameters: {},

  // Advanced
  timeout: 30000,
  fullResponse: false,
};

export default defaults;
